import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Articulo } from "@/shared/types/articulo";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteArticulo(id: string): Promise<Articulo> {
    await sleep(1000);
    const response = await api.delete("articulos/" + id);
    return response.data;
}

export function useDeleteArticuloMutation(id: string, mutationConfig: MutationConfig<Articulo> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteArticulo(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulos"] });
        },
    })
}

export interface DeleteArticuloMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Articulo>,
    children?:(mutationResult:MutationResult<Articulo>)=>ReactNode
}

export function DeleteArticuloMutation({
    id,
    children,
    mutationConfig
}:DeleteArticuloMutationProps){
    const mutationResult = useDeleteArticuloMutation(id, mutationConfig);
    return children&&children(mutationResult)
}